export default __webpack_public_path__ + "static/media/graceIconEmpty.0bbd6789.svg";